const awards = [
  { title: "Best Beauty Salon Muscat", titleAr: "أفضل صالون تجميل في مسقط", org: "Oman Observer", year: "2024" },
  { title: "Excellence in Beauty", titleAr: "التميز في مجال التجميل", org: "Times of Oman", year: "2024" },
  { title: "Top Salon Al Koudh", titleAr: "أفضل صالون في الخوض", org: "Muscat Daily", year: "2023" },
  { title: "Best Skincare Clinic", titleAr: "أفضل عيادة للعناية بالبشرة", org: "Oman Beauty Awards", year: "2023" },
  { title: "Customer Choice Award", titleAr: "جائزة اختيار العملاء", org: "Google Reviews", year: "2023" },
  { title: "Luxury Spa of the Year", titleAr: "أفضل سبا فاخر للعام", org: "Muscat Living", year: "2022" },
];

export default function AwardsSection() {
  return (
    <section className="py-16 sm:py-24 bg-[#1a2744] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Text */}
          <div>
            <p className="text-[#c6a864] text-xs tracking-[0.4em] uppercase mb-4 font-light">
              Our Achievements / إنجازاتنا
            </p>
            <h2
              className="text-white text-3xl sm:text-4xl font-light tracking-wide mb-2 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Awards &amp;{" "}
              <span className="italic text-[#c6a864]">Recognition</span>
            </h2>
            <p
              className="text-[#c6a864] text-2xl font-bold mb-2"
              style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
            >
              جوائزنا وتكريماتنا
            </p>
            <p
              className="text-white/60 text-sm mb-5 text-right"
              style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
            >
              تُعدّ جوائزنا دليلاً على التزامنا بتقديم أفضل خدمات التجميل في مسقط، الخوض وعموم سلطنة عمان.
            </p>
            <p className="text-white/60 text-sm leading-relaxed mb-8">
              Our commitment to excellence in Al Koudh, Muscat has been recognized
              by prestigious names in beauty and lifestyle. Every award drives us to
              continuously raise the bar for beauty in Oman.
            </p>
            <div className="grid grid-cols-2 gap-4">
              {awards.map((award) => (
                <div
                  key={award.title}
                  className="border border-white/10 p-4 hover:border-[#c6a864]/50 transition-colors duration-300"
                >
                  <div className="w-8 h-8 flex items-center justify-center mb-3">
                    <i className="ri-award-line text-[#c6a864] text-xl"></i>
                  </div>
                  <p className="text-white text-xs font-light mb-0.5">{award.title}</p>
                  <p className="text-[#c6a864]/80 text-xs mb-1" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{award.titleAr}</p>
                  <p className="text-white/40 text-xs tracking-wide">{award.org} &mdash; {award.year}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative h-[400px] sm:h-[560px] overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/94f753223eb91189255019b78a0c37ad.jpg"
              alt="Blue Moon Beauty Salon Muscat awards and recognition"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-l from-[#1a2744]/60 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
